import React from 'react';
import { Box, Heading, Text, Button, Flex, VStack, Icon, Image, Divider } from '@chakra-ui/react';
import { CheckCircleIcon } from '@chakra-ui/icons';
import { MdEmail } from 'react-icons/md';
import logoTotolac from 'assets/img/profile/logo.png';

const Success: React.FC = () => {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgGradient="linear(to-br, #f8f9fa, #e9ecef)"
      p={4}
    >
      <Box
        textAlign="center"
        p={8}
        maxW="600px"
        w="100%"
        borderRadius="2xl"
        bg="white"
        boxShadow="2xl"
        border="1px solid"
        borderColor="gray.200"
      >
        {/* Logo de Totolac */}
        <Flex justify="center" mb={6}>
          <Image
            src={logoTotolac}
            alt="Logo Totolac"
            h="100px"
            objectFit="contain"
          />
        </Flex>

        {/* Icono de éxito */}
        <Icon
          as={CheckCircleIcon}
          w={20}
          h={20}
          color="green.500"
          mb={4}
        />

        {/* Título */}
        <Heading
          as="h2"
          size="2xl"
          mb={4}
          bgGradient="linear(to-r, #16a34a, #15803d)"
          bgClip="text"
          fontWeight="bold"
        >
          ¡Pago Exitoso!
        </Heading>

        <Divider mb={6} borderColor="gray.300" />

        {/* Mensaje principal */}
        <VStack spacing={4} mb={6}>
          <Text fontSize="lg" color="gray.700" fontWeight="medium">
            Tu pago se ha procesado correctamente.
          </Text>

          {/* Información del comprobante */}
          <Box
            p={4}
            bg="blue.50"
            borderRadius="lg"
            border="1px solid"
            borderColor="blue.200"
            w="100%"
          >
            <Flex align="center" justify="center" mb={2}>
              <Icon as={MdEmail} w={5} h={5} color="blue.600" mr={2} />
              <Text fontSize="md" fontWeight="semibold" color="blue.800">
                Comprobante de Pago
              </Text>
            </Flex>
            <Text fontSize="sm" color="gray.600">
              El comprobante de pago será enviado a su correo electrónico en caso de haberlo proporcionado.
              De lo contrario, podrá visualizarlo en el portal ciudadano.
            </Text>
          </Box>

          <Text fontSize="md" color="gray.600" mt={2}>
            Gracias por utilizar nuestro portal ciudadano.
          </Text>
        </VStack>

        <Divider mb={6} borderColor="gray.300" />

        {/* Botón de volver */}
        <Button
          bgGradient="linear(to-r, #681a2d, #5b182b)"
          color="white"
          size="lg"
          w="100%"
          _hover={{
            bgGradient: "linear(to-r, #7a1f36, #6c1e33)",
            transform: "translateY(-2px)",
            boxShadow: "lg"
          }}
          _active={{
            bgGradient: "linear(to-r, #5a1625, #4d1523)"
          }}
          transition="all 0.2s"
          onClick={() => window.location.assign('https://portalciudadano.totolac.gob.mx/')}
        >
          Volver al Inicio
        </Button>
      </Box>
    </Flex>
  );
};

export default Success;
